export function getContrastTextColor(hexColor: string): string {
	// Remove # if present
	const hex = hexColor.replace("#", "");

	// Convert hex to RGB
	const r = parseInt(hex.substring(0, 2), 16);
	const g = parseInt(hex.substring(2, 4), 16);
	const b = parseInt(hex.substring(4, 6), 16);

	// Calculate luminance using relative luminance formula
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

	// Return dark text for light backgrounds, same color for dark backgrounds
	return luminance > 0.5 ? "#1f1f1f" : hexColor;
}

export function getTextColorForBackground(hexColor: string): string {
	// Remove # if present
	const hex = hexColor.replace("#", "");

	// Convert hex to RGB
	const r = parseInt(hex.substring(0, 2), 16);
	const g = parseInt(hex.substring(2, 4), 16);
	const b = parseInt(hex.substring(4, 6), 16);

	// Calculate luminance using relative luminance formula
	const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

	if (luminance > 0.6) {
		// If the color is light, return a darker version of the same color
		const factor = 0.4; // 0 = black, 1 = original
		const darken = (c: number) => Math.max(0, Math.floor(c * factor));
		const dr = darken(r).toString(16).padStart(2, "0");
		const dg = darken(g).toString(16).padStart(2, "0");
		const db = darken(b).toString(16).padStart(2, "0");
		return `#${dr}${dg}${db}`;
	} else {
		// If the color is dark, return white
		return "#ffffff";
	}
}

export async function copyToClipboard(text: string) {
	if (navigator.clipboard && window.isSecureContext) {
		await navigator.clipboard.writeText(text);
	} else {
		// Fallback for HTTP / old browsers
		const textarea = document.createElement("textarea");
		textarea.value = text;
		textarea.style.position = "fixed";
		textarea.style.left = "-9999px";
		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();
		document.execCommand("copy");
		textarea.remove();
	}
}
